import { render, staticRenderFns } from "./TransferCpgg.vue?vue&type=template&id=7e84ec40&scoped=true&"
import script from "./TransferCpgg.vue?vue&type=script&lang=js&"
export * from "./TransferCpgg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e84ec40",
  null
  
)

export default component.exports